module.exports = __webpack_public_path__ + "static/BannerEducation-51baef2651ad0536043f32a47fa3b6e0.png";